import { render, staticRenderFns } from "./ArticleScopeHospitalDepartment.vue?vue&type=template&id=a304e492&scoped=true"
import script from "./ArticleScopeHospitalDepartment.vue?vue&type=script&lang=js"
export * from "./ArticleScopeHospitalDepartment.vue?vue&type=script&lang=js"
import style0 from "./ArticleScopeHospitalDepartment.vue?vue&type=style&index=0&id=a304e492&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a304e492",
  null
  
)

export default component.exports